import { render } from "./SayHello.vue?vue&type=template&id=3b112880"
import script from "./SayHello.vue?vue&type=script&lang=js"
export * from "./SayHello.vue?vue&type=script&lang=js"

import "./SayHello.vue?vue&type=style&index=0&id=3b112880&lang=css"
script.render = render

export default script